<template lang="pug">
van-nav-bar(:title='docFileName' fixed :left-arrow="hasLeft" @click-left='onClickLeft' )
</template>

<script>
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  computed: {
    isLoginFree() {
      return this.$route.query.isLoginFree || "";
    },
    hasLeft() {
      return !this.$route.query.i;
    },
    filData() {
      return JSON.parse(mongeApp.other.fileInfo);
    },
    docFileName() {
      return decodeURIComponent(this.filData.fileName) || "未命名";
    }
  },
  methods: {
    // 头部按钮返回
    onClickLeft() {
      const data = { source: "back" };
      let { isH5 } = this.$route.query || {};
      mongeApiMlib.rebackLastPage(this.isLoginFree || isH5, data);
    }
  }
};
</script>

<style lang="scss" scoped>
.van-nav-bar__content {
  height: 88upx;
}
</style>
